import React from "react";
import { Form } from "react-final-form";
import { Checkbox } from "../../../../../common/components/input/Checkbox";
import { SettingRow } from "./SettingRow";

type ResidencySettingsFields = {
  hideLocationDropdownOnRequestForm: boolean;
  addOtherOptionToLocationDropdownOnRequestForm: boolean;
};

export function PrivacyCenterResidencySettingsRow({
  residencySettingsFields,
  handleFormSubmit,
}: {
  residencySettingsFields: ResidencySettingsFields;
  handleFormSubmit: (fields: ResidencySettingsFields) => void;
}) {
  const helpText = "Allow people who live outside of required regions to submit privacy requests.";
  return (
    <SettingRow title="Residency" helpText={helpText}>
      <Form
        initialValues={residencySettingsFields}
        onSubmit={handleFormSubmit}
        render={({ handleSubmit }) => {
          return (
            <>
              <div className="mb-md w-445">
                <Checkbox
                  field="hideLocationDropdownOnRequestForm"
                  color="primary"
                  label={'Remove "Location" drop-down on request form'}
                  className="mb-xxs"
                  afterChange={handleSubmit}
                />
                <div className="text-t1 text-muted">
                  Select this option to remove the "Location" requirement entirely. This means you
                  will not be able to track where any requestors are located.
                </div>
              </div>
              {!residencySettingsFields.hideLocationDropdownOnRequestForm && (
                <div className="w-445">
                  <Checkbox
                    field="addOtherOptionToLocationDropdownOnRequestForm"
                    color="primary"
                    label={'Add "Other" option to location drop-down'}
                    className="mb-xxs"
                    afterChange={handleSubmit}
                  />
                  <div className="text-t1 text-muted">
                    Select this to add an "Other" location to the Location drop-down that people who
                    are outside of a required region can select. You will still be able to track
                    where requestors in required states reside.
                  </div>
                </div>
              )}
            </>
          );
        }}
      />
    </SettingRow>
  );
}
